import { OutDebt } from '../generated/graphql';
import { getNegBooleans } from './getNegBooleans';

export const getMainOutDebtFromParent = (
  outDebt: OutDebt,
) => (getNegBooleans(outDebt).isVirtualDebt
  ? (outDebt.extra?.children || []).sort((odA, odB) => (odB.balance || 0) - (odA.balance || 0))[0]
  : outDebt);
